export default "__VITE_ASSET__e853e655__"